export default __webpack_public_path__ + "static/media/placement-responsibilities.9364cedb.svg";